/**
 * 页面字典数据接口
 */
import request from '@/utils/requestUtil';

const API = {
  PUBLIC_KEY_URL: "/uaa/public-key",
  IMAGE_CODE_URL: '/auth/authUser/code/image',
  IMAGE_CHECK_URL: '/auth/authUser/code/check',
  USER_MOBILE_CODE_URL: '/pub/sms/sendLoginSMSVerCode',
  USER_LOGIN_URL: '/uaa/authLogin',
}

// 获取加密公钥
export const reqRsaCode = () => request.get(API.PUBLIC_KEY_URL);
// 图形验证码
export const reqImageCode = () => request.get(API.IMAGE_CODE_URL);
// 检查图形验证码
export const reqImageCheck = (url) => request.get(API.IMAGE_CHECK_URL + url);
// 获取手机验证码
export const reqMobileCode = (mobile) => request.post(API.USER_MOBILE_CODE_URL + `?mobile=${mobile}`);
// 用户登录
export const reqUserLogin = (dataInfo) => request.post(API.USER_LOGIN_URL, dataInfo);
// 刷新token
export const reqRefreshToken = (data) => request.post(API.USER_LOGIN_URL, data);
